import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import React from 'react';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('OverlayAnimation');

const propTypes = {
    children: PropTypes.any,
    transitionName: PropTypes.string,
    transitionEnterTimeout: PropTypes.number,
    transitionLeaveTimeout: PropTypes.number,
};

const defaultProps = {
    transitionName: bem(),
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300,
};

function OverlayAnimation({ children, transitionName, transitionEnterTimeout, transitionLeaveTimeout }) {
    return (
        <TransitionGroup>
            {React.Children.map(children, (child, idx) => (
                <CSSTransition
                    key={`css-tr-${idx}`}
                    classNames={{
                        enter: transitionName + '--enter',
                        enterActive: transitionName + '--enterActive',
                        exit: transitionName + '--leave',
                        exitActive: transitionName + '--leaveActive',
                    }}
                    timeout={{ enter: transitionEnterTimeout, exit: transitionLeaveTimeout }}
                >
                    {child}
                </CSSTransition>
            ))}
        </TransitionGroup>
    );
}

OverlayAnimation.propTypes = propTypes;
OverlayAnimation.defaultProps = defaultProps;

export default OverlayAnimation;
